// Brand asset paths (served from /public/brand/)
export const BRAND = {
  logo: "/brand/logo.png",
  hero: "/brand/hero-colorado.jpg",
  community: "/brand/community-banner.jpg",
  divider: "/brand/divider.jpg",
};

// Default fallback hero used on listing detail pages and listing cards
// when a listing has no `hero_url` of its own.
export const DEFAULT_LISTING_HERO = BRAND.hero;
